import React, { Component } from 'react';
import { translate } from '~/decorators';
import './ApiError.scss';

export default
@translate('base.api-error')
class ApiError extends Component {
    render() {
        const {
            children,
            t,
            style
        } = this.props;

        return (
            <div
                className="api-error"
                style={style}
            >
                {t(children)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/base/ApiError.js